module.exports = __webpack_public_path__ + "static/DINPro-Bold-2edfa21f4d41a69c1b2dd3f886d393fa.woff2";